import type { ComponentProps } from 'react';
import { OwcStepper } from '@one/react';

export type PocStepperProps = ComponentProps<typeof OwcStepper>;

export const PocStepper: React.FC<PocStepperProps> = (props) => <OwcStepper {...props} />;
